export const NOTIFICATION_VISIBLE_MS = 3000;
export const NOTIFICATION_TRANSITION_MS = 300;
